var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.179 5.65394C13.6235 5.65394 12.358 4.38576 12.358 2.82697C12.358 1.26818 13.6235 0 15.179 0C16.7345 0 18 1.26818 18 2.82697C18 4.38576 16.7345 5.65394 15.179 5.65394ZM17.2856 7.79344V15.113C17.2856 16.7074 15.9957 18 14.4046 18H2.88093C1.28983 18 0 16.7074 0 15.113V3.56489C0 1.97044 1.28983 0.677873 2.88093 0.677873H10.1682C10.566 0.677873 10.8885 1.00101 10.8885 1.39963C10.8885 1.79824 10.566 2.12138 10.1682 2.12138H2.88093C2.08538 2.12138 1.44046 2.76766 1.44046 3.56489V15.113C1.44046 15.9102 2.08538 16.5565 2.88093 16.5565H14.4046C15.2002 16.5565 15.8451 15.9102 15.8451 15.113V7.79344C15.8451 7.39483 16.1676 7.07169 16.5653 7.07169C16.9631 7.07169 17.2856 7.39483 17.2856 7.79344ZM7.80487 7.74084L10.2855 9.99321L13.0466 7.93592C13.2716 7.75468 13.5778 7.71181 13.8439 7.82429C14.1099 7.93677 14.2929 8.18645 14.3205 8.4745C14.348 8.76254 14.2156 9.0425 13.9757 9.20354L10.6678 11.6507C10.3678 11.8692 9.95613 11.8477 9.68047 11.599L7.2057 9.33204L3.75551 11.5857C3.54007 11.7235 3.27118 11.7477 3.03472 11.6505C2.88327 11.5905 2.75416 11.4848 2.66527 11.3481C2.55122 11.1719 2.51211 10.9574 2.55665 10.7523C2.60118 10.5471 2.72567 10.3683 2.90243 10.2555L6.85411 7.66153C7.15259 7.46998 7.5421 7.50247 7.80487 7.74084Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActivity);
export default __webpack_public_path__ + "static/media/icon-activity.3fe3c5cc59a48162fa59f1932e5c467b.svg";
export { ForwardRef as ReactComponent };